import type { DataSotaRepository } from './contracts.js';
import { ApiDataSotaRepository } from './apiRepository.js';
import { resolveDataMode } from './dataMode.js';
import { MockDataSotaRepository } from './mockRepository.js';

const dataMode = resolveDataMode(import.meta.env.VITE_DATA_MODE);

function createRepository(mode: typeof dataMode): DataSotaRepository {
  if (mode === 'mock') return new MockDataSotaRepository();
  if (mode === 'api') return new ApiDataSotaRepository();
  return mode satisfies never;
}

export const repository = createRepository(dataMode);
